import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Layout from "src/components/layout/website/Layout";
import Button from "src/components/ui/Button";

const HomePage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <Layout>
      <div className="min-h-screen bg-white text-gray-800">
        {/* Hero */}
        <section className="text-center py-24 px-6 bg-gradient-to-b from-indigo-50 to-white">
          <h1 className="text-5xl font-bold mb-4 text-indigo-600">
            Simplify Your Inventory Management
          </h1>
          <p className="text-lg mb-8 text-gray-600 max-w-2xl mx-auto">
            Invyntra helps businesses track stock, purchases, and sales
            seamlessly — all in one smart dashboard.
          </p>
          <Button onClick={() => navigate("/pricing")}>Get Started</Button>
        </section>

        {/* Features */}
        <section className="py-16 bg-gray-50">
          <div className="max-w-6xl mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-10">
            {[
              {
                title: "Real-Time Tracking",
                desc: "Monitor your stock, sales, and purchase movements live with insightful dashboards.",
                img: "/assets/feature-realtime.svg",
              },
              {
                title: "Multi-Tenant Ready",
                desc: "Manage multiple clients or branches easily with Invyntra’s tenant-based access.",
                img: "/assets/feature-multitenant.svg",
              },
              {
                title: "Advanced Reports",
                desc: "Visualize data with daily, monthly, or custom reports. Export instantly in Excel.",
                img: "/assets/feature-reports.svg",
              },
            ].map((f, i) => (
              <div
                key={i}
                className="bg-white p-6 rounded-xl shadow hover:shadow-lg transition"
              >
                <img src={f.img} alt={f.title} className="h-32 mx-auto mb-4" />
                <h3 className="font-semibold text-lg mb-2">{f.title}</h3>
                <p className="text-gray-600 text-sm">{f.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* CTA */}
        <section className="text-center py-20">
          <h2 className="text-3xl font-bold mb-4">
            Ready to take control of your inventory?
          </h2>
          <Link
            to="/contact"
            className="bg-indigo-600 text-white px-6 py-3 rounded-lg hover:bg-indigo-700 transition"
          >
            Request a Demo
          </Link>
        </section>
      </div>
    </Layout>
  );
};

export default HomePage;
